export default {
    root: {
        display: "flex",
        flexDirection: "column",
        gap: 1,
        mb: 2.5
    },
    title: {
        color: "primary.700",
        letterSpacing: "-0.005em"
    },
    subtitle: {
        display: "block",
        color: "greyscale.700",
        maxWidth: 620,
        lineHeight: 1.5
    },
    endpointRow: {
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        mt: 0.75
    },
    endpointLabel: {
        color: "greyscale.600",
        textTransform: "uppercase",
        fontWeight: 600,
        whiteSpace: "nowrap"
    },
    endpointPill: {
        display: "inline-flex",
        alignItems: "center",
        gap: 0.5,
        height: 30,
        pl: 1.25,
        pr: 0.5,
        borderRadius: "8px",
        border: "1px solid",
        borderColor: "greyscale.200",
        backgroundColor: "additional.white"
    },
    endpointValue: {
        fontFamily: "monospace",
        fontSize: "12px",
        color: "greyscale.900"
    },
    copyButton: {
        color: "greyscale.700"
    },
    copyButtonCopied: {
        color: "success.500"
    }
};
